import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    filters: {
        equipUid: null,
        hp: null,
        location: null,
        model: null,
        status: null,
        uType: null,
    },
    equipmentFilters: {
        equipUid: null,
        hp: null,
        location: null,
        model: null,
        status: null,
        uType: null,
        
    }
}

export const filterSlice = createSlice({
    name: 'filterSlice',
    initialState,
    reducers: {
        setLocomotiveFilters: (state, { payload }) => {
            state.filters = payload
        },
        resetLocomotiveFilters: (state, { payload }) => {
            state.filters = {
                equipUid: null,
                hp: null,
                location: null,
                model: null,
                status: null,
                uType: null,
            }

        },
        setEquipmentFilters: (state, { payload }) => {
             
            state.equipmentFilters = payload
        },
        resetEquipmentFilters: (state, { payload }) => {
            state.equipmentFilters = {
                equipUid: null,
                hp: null,
                location: null,
                model: null,
                status: null,
                uType: null,
                
            }

        },
    },
})

// Action creators are generated for each case reducer function
export const { setEquipmentFilters, setLocomotiveFilters, resetEquipmentFilters, resetLocomotiveFilters } = filterSlice.actions

export default filterSlice.reducer